export class Salary {
    id: number;
    userId: number;
    amount: number = 0;
    effectiveDate: Date = new Date();
    reason: string;
    remarks: string;
    createdBy: number;
    createdDate: string;
    updatedBy: number;
    updatedDate: string;

    //not in model
    percentDifference: number;
}


// WEBPACK FOOTER //
// ./src/app/models/salaries/salary.ts